import { render, staticRenderFns } from "./FolderListFooter.vue?vue&type=template&id=2f20432a&scoped=true&"
import script from "./FolderListFooter.vue?vue&type=script&lang=js&"
export * from "./FolderListFooter.vue?vue&type=script&lang=js&"
import style0 from "./FolderListFooter.vue?vue&type=style&index=0&id=2f20432a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f20432a",
  null
  
)

export default component.exports